var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button__content"},[_c('button',{staticClass:"button__betslip",on:{"click":_vm.handleClickOpenBetSlip}},[_vm._v(" "+_vm._s(_vm.getTranslatedText(`betslip`))+" "),(_vm.getBetslips.length > 0)?_c('span',{staticClass:"button__betslip--number badge"},[_vm._v(" "+_vm._s(_vm.getBetslips.length)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }